import { render, staticRenderFns } from "./NoLottery.vue?vue&type=template&id=66b76824&scoped=true&"
import script from "./NoLottery.vue?vue&type=script&lang=ts&"
export * from "./NoLottery.vue?vue&type=script&lang=ts&"
import style0 from "./NoLottery.vue?vue&type=style&index=0&id=66b76824&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66b76824",
  null
  
)

export default component.exports